function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SiteLinkManager from '../infrastructure/site-link-manager';
import { SiteLinks } from '../infrastructure/const';
// import Logger from '../../../../wdh-logger/wdh-logger';

/**
 * Navigration manager to handle navigtaion to other shop sites
 * @memberOf module:wdh-feature-b2b
 */
var NavigationManager = /*#__PURE__*/function () {
  function NavigationManager() {
    _classCallCheck(this, NavigationManager);
  }
  return _createClass(NavigationManager, null, [{
    key: "navigate",
    value:
    /**
     * Navigates to given url
     * @param {String} url  The url to navigate to
     */
    function navigate(url) {
      window.location.href = url;
    }

    /**
     * Navigates to the Cart Details Page
     */
  }, {
    key: "navigateToCartDetails",
    value: function navigateToCartDetails() {
      var url = '/myoticon/shop/cart-details';
      NavigationManager.navigate(url);
    }

    /**
     * Navigates to the Service order Page
     */
  }, {
    key: "navigateToServiceOrder",
    value: function navigateToServiceOrder() {
      var url = '/myoticon/service-order';
      NavigationManager.navigate(url);
    }
  }, {
    key: "navigateToSchedulePickup",
    value: function navigateToSchedulePickup() {
      var url = '/myoticon/myaccount/schedule-pick-up';
      NavigationManager.navigate(url);
    }

    /**
     * Navigates to the My repairs Page
     */
  }, {
    key: "navigateToMyRepairs",
    value: function navigateToMyRepairs() {
      var url = '/myoticon/myaccount/orders/my-repairs';
      NavigationManager.navigate(url);
    }

    /**
     * Navigates to the Checkout Page
     */
  }, {
    key: "navigateToCheckout",
    value: function navigateToCheckout() {
      var url = SiteLinkManager.getSiteLink(SiteLinks.CHECKOUT);
      NavigationManager.navigate(url);
    }

    /**
     * Navigates to the Shop front page
     */
  }, {
    key: "navigateToShopFrontPage",
    value: function navigateToShopFrontPage() {
      var url = SiteLinkManager.getSiteLink(SiteLinks.HOME);
      NavigationManager.navigate(url);
    }

    /**
     * Navigates to the Order history page
     */
  }, {
    key: "navigateToOrderhistoryPage",
    value: function navigateToOrderhistoryPage() {
      var url = SiteLinkManager.getSiteLink(SiteLinks.ORDERHISTORY);
      NavigationManager.navigate(url);
    }
  }]);
}();
export default NavigationManager;